import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Link, NavLink, useLocation } from 'react-router-dom';
import armchair from '../assets/armchair-green-living-room-with-copy-space-min.jpg';
import livingRoom from '../assets/main-background.jpg';
import gallery from '../assets/seo-galaxy-iLloBoLYxCE-unsplash-min.jpg';
import Gallery from './Gallery';
import Infrastructure from './Infrastructure';
import Services from './Services';
import Contact from './Contact';
import logo from '../assets/Shape Logo 1.png';
import About from './About';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../Config/Config';


const menu = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About US' },
  // { to: '/mission-vision', label: 'Mission & Vision' },
  { to: '/infrastructure', label: 'Infrastructure' },
  { to: '/services', label: 'Services' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact us' },
  { to: '/login', label: 'Login' },
];


const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6 } },
};
const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};
const HeroCard = ({ children, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
    className={`bg-white rounded-md p-4 shadow-soft hover:shadow-lg transition-shadow h-full flex items-center ${className}`}
  >
    {children}
  </motion.div>
);

const SideNav = ({ className = "" }) => {
  const { pathname } = useLocation();
  return (
    <nav className={`hidden lg:flex z-40 flex-col gap-3 ${className}`}>
      {menu.map((item, idx) => (
        <NavLink key={item.to} to={item.to}
          className={({ isActive }) => `block ${isActive ? 'pointer-events-none' : ''}`}>
          {({ isActive }) => (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.04 }}
              className={`px-5 py-2.5 rounded-full shadow-soft backdrop-blur border text-sm font-medium transition-colors
                ${isActive ? 'bg-brand-primary text-white border-brand-primary ring-1 ring-brand-primary/30' : 'bg-brand-primary/90 text-white border-brand-primary/30 hover:bg-brand-primary hover:text-white'}`}
            >
              {item.label}
            </motion.div>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

const Home = () => {
  const scrollerRef = useRef(null);
  const scrollByAmount = (delta) => scrollerRef.current?.scrollBy({ left: delta, behavior: 'smooth' });

 const [homeData, setHomeData] = useState(null);
 const [services, setServices] = useState([]);
  const [infra, setInfra] = useState([]);
//============================================================home data==============================//
  useEffect(() => {
    const getData = async () => {
      const ref = doc(db, "website-management", "home-page");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setHomeData(snap.data());
      } else {
        console.log("home-page document not found");
      }
    };

    getData();
   fetchInfrastructureData();
   
  }, []);

    const fetchInfrastructureData = async () => {
          const ref = collection(db, "website-management", "feedback", "data");
          const snap = await getDocs(ref);
    
          const arr = snap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
    
          setInfra(arr);
        }
const words = homeData?.title?.split(" ") || [];
const line1 = words.slice(0, 3).join(" ");
const line2 = words.slice(3).join(" ");
//============================================================service data==============================//
  
  return (
    <div className="pb-16">
      <section className="relative mt-0 md:mt-0 -mx-4 sm:-mx-6 lg:-mx-8">
        <div className="relative overflow-hidden bg-cover bg-center h-[420px] md:h-[560px]" style={{ backgroundImage: `url(${livingRoom})` }}>
          <div className="absolute inset-0 bg-gradient-to-br from-white/80 via-white/50 to-transparent" />
          <motion.div className="relative h-full px-4 sm:px-6 lg:px-8 py-10 md:py-12 flex flex-col justify-center max-w-7xl mx-auto" variants={stagger} initial="hidden" animate="visible">
            <motion.span variants={fadeUp} className="inline-block w-fit px-3 py-1  text-2xl font-medium  flex items-center gap-2"><img src={logo} alt="logo" className="w-8 h-8" />Shape Interior Solutions</motion.span>
            <motion.h1 variants={fadeUp} className="mt-3 text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
            {line1}
              <br className="hidden md:block" />
             {line2}
            </motion.h1>
            <motion.p variants={fadeUp} className="mt-4 text-slate-700 max-w-xl">{homeData?.description}</motion.p>
            <motion.div variants={fadeUp} className="mt-6 flex gap-3">
              <Link to="/services" className="inline-block bg-gradient-to-r from-brand-primary to-brand-dark text-white px-5 py-3 rounded-lg shadow-soft hover:shadow-lg">View our services</Link>
              <Link to="/contact" className="inline-block border border-brand-primary text-brand-primary px-5 py-3 rounded-lg hover:bg-brand-primary hover:text-white transition-colors">Contact us</Link>
            </motion.div>

          </motion.div>
          {/* <div className="absolute right-6 top-1/2 -translate-y-1/2">
            <SideNav className="flex flex-col gap-3" />
          </div> */}

        </div>
        <motion.div className="relative mt-8 w-full" variants={fadeIn} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          {/* edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-white/60 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-12 w-10 bg-gradient-to-l from-white/60 to-transparent" />
          <div ref={scrollerRef} className="flex gap-5 overflow-x-auto no-scrollbar pr-24 snap-x snap-mandatory">
            {infra.length > 0 && infra.map((item, i) => (
              <div key={i} className="min-w-[520px] sm:min-w-[600px] snap-start h-full">
                <HeroCard className="min-h-[120px]">
                  <div className="grid grid-cols-[112px_1fr] gap-5 items-center w-full">
                    <img alt="person" className="w-[112px] h-[112px] object-cover" src={item.image || 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?q=80&w=512&auto=format&fit=crop'} />
                    <p className="text-sm text-slate-800">{item.feedback}</p>
                  </div>
                </HeroCard>
              </div>
            ))}
           
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center gap-2 pr-2">
            <button aria-label="Scroll left" onClick={() => scrollByAmount(-360)} className="hidden sm:grid w-10 h-10 place-content-center text-3xl leading-none text-black">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-left-icon lucide-circle-chevron-left"><circle cx="12" cy="12" r="10"/><path d="m14 16-4-4 4-4"/></svg>

            </button>
            <button aria-label="Scroll right" onClick={() => scrollByAmount(360)} className="grid w-10 h-10 place-content-center text-3xl leading-none text-black">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-right-icon lucide-circle-chevron-right"><circle cx="12" cy="12" r="10"/><path d="m10 16 4-4-4-4"/></svg>

            </button>
          </div>
        </motion.div>
      </section>

      {/* <section className="mt-14 grid md:grid-cols-2 gap-10 items-center max-w-7xl mx-auto">
        <img alt="workshop" src={armchair} className="rounded-xl shadow-soft h-[500px] object-cover" />
        <div>
          <h2 className="text-2xl md:text-3xl font-bold">About <span className="text-brand-primary">Shape</span> Interior Solutions</h2>
          <p className="mt-3 text-slate-700 text-xl text-justify text-gray-600">
            Let us introduce ourselves as one and only total
            solution provider in the domain of Interior in Kerala
            “Focusing on Projects and B2B Solutions“. Transition
            from a traditional system was very difficult and
            proudly we could make it within very short span of
            time and we became pioneer in this domain. Our focus
            i business verticals one is only for Job Work in the
            name of “Shape Interior Solutions”
            with the objective of extended on-site support.
          </p>
          <Link to="/about" className="inline-block mt-5 px-5 py-2.5 rounded-lg bg-gradient-to-r from-brand-primary to-brand-dark text-white shadow-soft">Get in touch</Link>
        </div>
      </section>

      <section className="mt-16 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h3 className="text-2xl font-bold">Mission & Vision</h3>
            <p className="mt-3 text-slate-700 text-xl text-justify text-gray-600">
              The <span className="font-bold text-brand-primary">Mission</span> of a specific job is to transform an
              interior space to meet the client's functional, safety,
              and aesthetic requirements within a set budget and
              timeline.

            </p>
            <p className="mt-3 text-slate-700 text-xl text-justify text-gray-600 font-family-sans">
              <span className="font-bold text-brand-primary">Vision : </span>We focus on the ultimate desired future state
              and the positive impact on clients' lives and spaces.
              And we value Inspiration, Future-Oriented Projects,
              Uniqueness and sustainability
            </p>
            <div className="mt-4 flex gap-3">
              <Link to="/services" className="px-5 py-2.5 rounded-lg bg-gradient-to-r from-brand-primary to-brand-dark text-white shadow-soft">Services</Link>
              <Link to="/contact" className="px-5 py-2.5 rounded-lg border border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white transition-colors">Contact us</Link>
            </div>
          </div>
          <img alt="mission" src={gallery} className="rounded-xl shadow-soft h-[450px] object-cover" />
        </div>
      </section> */}
      <motion.section variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
        <About/>
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
        <Infrastructure />
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
        <Services />
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
        <Gallery />
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
        <Contact/>
      </motion.section>
      
    </div>
  );

};

export default Home;

